export const transferDetailsEn = {};

export const transferDetailsFr = {};
